import { WebsiteAlertService } from './WebsiteAlertService';

export function initWebsiteAlert() {
  let element = document.getElementsByClassName(
    'website-alert-enabled'
  )[0] as HTMLElement;

  if (typeof element == 'undefined' && element == null) {
    return;
  }

  WebsiteAlertService.checkAuthenticationErrors();
}
